import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("mdi-baby-face-outline")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Babyhead Viewer (α)")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("mdi-upload")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("スキャンモデルを読み込む")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("mdi-trash-can")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("読み込んだモデルを非表示")
const _hoisted_7 = { class: "text-caption mr-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-caption" }, "Japan Medical Company", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("mdi-email")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("お問い合わせ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "d-block mb-1" }, "本アプリの操作に関するお問い合わせ、ご要望は、以下メールアドレス宛にお願いします。", -1)
const _hoisted_12 = { class: "d-block mb-1" }
const _hoisted_13 = {
  class: "text-decoration-none text-primary",
  href: "mailto:support@japanmedicalcompany.co.jp"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("mdi-email")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("support@japanmedicalcompany.co.jp")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "d-block" }, "発注等、その他に関するお問い合わせは、弊社各営業担当にお願いします。", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_model_viewer = _resolveComponent("model-viewer")!
  const _component_pane = _resolveComponent("pane")!
  const _component_splitpanes = _resolveComponent("splitpanes")!
  const _component_file_drop = _resolveComponent("file-drop")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createBlock(_component_v_layout, { "full-height": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, { density: "compact" }, {
        prepend: _withCtx(() => [
          _createVNode(_component_v_icon, {
            class: "ml-2",
            color: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_title, {
            class: "pl-4 text-primary text-body-1",
            style: {"margin-bottom":"2px"}
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            class: "mr-2",
            color: "primary",
            variant: "outlined",
            onClick: _ctx.upload
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { class: "mr-1" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            class: "mr-4",
            variant: "outlined",
            disabled: _ctx.state.files.length <= 0,
            onClick: _ctx.removeAll
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { class: "mr-1" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_v_switch, {
            disabled: _ctx.state.files.length <= 1,
            modelValue: _ctx.state.syncCamera,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.syncCamera) = $event)),
            color: "primary",
            class: "flex-grow-0",
            label: "モデルを同期する",
            "hide-details": true
          }, null, 8, ["disabled", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, { style: {"min-height":"100vh"} }, {
        default: _withCtx(() => [
          _createVNode(_component_splitpanes, { class: "default-theme h-100" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.files, (file, idx) => {
                return (_openBlock(), _createBlock(_component_pane, {
                  key: idx,
                  "min-size": 1,
                  "max-size": 100,
                  class: "d-flex h-100",
                  style: {"background":"white"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_model_viewer, {
                      index: idx,
                      file: file,
                      syncCamera: _ctx.state.syncCamera,
                      syncedCameraTransform: _ctx.state.syncedCameraTransform,
                      "onUpdate:cameraTransform": _ctx.updateCameraTransform
                    }, null, 8, ["index", "file", "syncCamera", "syncedCameraTransform", "onUpdate:cameraTransform"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_file_drop, {
            dialog: _ctx.state.dialog,
            "onSubmit:files": _ctx.submit,
            "onUpdate:dialog": _cache[1] || (_cache[1] = ($event: any) => {_ctx.state.dialog = $event;})
          }, null, 8, ["dialog", "onSubmit:files"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_footer, {
        app: "",
        class: "elevation-4"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_7, "© " + _toDisplayString(new Date().getFullYear()), 1),
          _hoisted_8,
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "outlined",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.inquiry = true))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { class: "mr-1" }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        "model-value": _ctx.state.inquiry,
        "onClick:outside": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.inquiry = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "text-body-1 pa-4" }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _createElementVNode("p", _hoisted_12, [
                    _createElementVNode("a", _hoisted_13, [
                      _createVNode(_component_v_icon, { class: "mr-1" }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }),
                      _hoisted_15
                    ])
                  ]),
                  _hoisted_16
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model-value"])
    ]),
    _: 1
  }))
}